import { render } from "./MyAccountProductsList.vue?vue&type=template&id=6418b8c2"
import script from "./MyAccountProductsList.vue.ts?vue&type=script&lang=ts"
export * from "./MyAccountProductsList.vue.ts?vue&type=script&lang=ts"
script.render = render

export default script